import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthDetailsService} from '../auth/auth-details.service';
import {AppConstants} from "../utils/constants";
import {map} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class AuthGuardService  {

  constructor(private _authService: AuthDetailsService, private _http: HttpClient) {
  }

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    //todo: It should be possible to do just one request to "window.location.origin + AppConstants.rootPath + next.url"
    // and perform the redirect windows.location... and the location header, if present
    return this._authService.isAuthenticationRequired().pipe(map(isAuthenticationRequired => {
      if(isAuthenticationRequired) {
        window.location.assign(window.location.origin + AppConstants.authenticationRedirectEndpoint + "?path=" + encodeURIComponent(next.url.map(segment => segment.path).join('/')));
        return false;
      }
      return true;
    }));
  }

}
